import { render } from "./BasketPage.vue?vue&type=template&id=23b9cbcd"
import script from "./BasketPage.vue?vue&type=script&lang=js"
export * from "./BasketPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__